import { TypeOf } from '../../../helpers'
import { Screen } from '../../../data/models'
import { IScreenComponent, IConfigScreenComponent } from './'

export class ScreenComponentResolver {
  private DEFAULT_TYPE = 'default'

  public constructor(private _componentMap: {[key: string]: TypeOf<IScreenComponent | IConfigScreenComponent>} = {}) {}

  public getComponentClass(screen: Screen) {
    const screenType = this._getScreenType(screen)
    const component = this._componentMap[screenType] || this._componentMap[this.DEFAULT_TYPE]

    return {
      component: component,
      initStrategy: screenType ? this._configuredScreenInitStrategy() : this._baseInitStrategy()
    }
  }

  private _baseInitStrategy() {
    return (screenComponent, options: {}) => {
      screenComponent.screen = options['screen']
    }
  }

  private _configuredScreenInitStrategy() {
    return (screenComponent, options: {}) => {
      screenComponent.screen = options['screen']
      screenComponent.execution = options['execution']
    }
  }

  private _getScreenType(screen: Screen): string {
    return screen.getConfig('type')
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/exam-screen/screen-component-resolver.ts